import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import "../Assets/WebsiteCss/Footer.css";
import { FaLocationDot, FaSquarePhone } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";
import logo from "../Assets/images/footer_logo.png";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top-strip"></div>

      <Container>
        <Row className="gy-4 footer-main-row">
          {/* Column 1 – Logo & Info */}
          <Col lg={4} md={6} sm={12}>
            <div className="footer-brand">
              <img
                src={logo}
                alt="R K Constructions Logo"
                className="footer-logo"
              />
            </div>
            <p className="footer-description">
              Welcome to <strong>RK Constructions</strong>, your trusted partner
              in civil engineering and construction excellence. With over 15
              years of experience.
            </p>
          </Col>

          {/* Column 2 – Quick Links */}
          <Col lg={2} md={6} sm={6} xs={6}>
            <h6 className="footer-heading">Quick Links</h6>
            <ul className="footer-links">
              <li>
                <NavLink to="/">Home</NavLink>
              </li>
              <li>
                <NavLink to="/about-us">About Us</NavLink>
              </li>
              <li>
                <NavLink to="/projects">Projects</NavLink>
              </li>
              <li>
                <NavLink to="/contact">Contact</NavLink>
              </li>
            </ul>
          </Col>

          {/* Column 3 – Services */}
          <Col lg={3} md={6} sm={6} xs={6}>
            <h6 className="footer-heading">Services</h6>
            <ul className="footer-links">
              <li>
                <NavLink to="/services/planning">Building Planning</NavLink>
              </li>
              <li>
                <NavLink to="/services/construction">
                  Construction Planning
                </NavLink>
              </li>
              <li>
                <NavLink to="/services/interior">Interior Planning</NavLink>
              </li>
              {/* <li>
                <NavLink to="/contact">Contact</NavLink>
              </li> */}
            </ul>
          </Col>

          {/* Column 4 – Contact Us */}
          <Col lg={3} md={6} sm={12}>
            <h6 className="footer-heading">Contact Us</h6>
            <ul className="footer-contact">
              <li>
                <FaLocationDot className="footer-icon" />
                <span>Shalgaon, Maharashtra</span>
              </li>
              <li>
                <FaSquarePhone className="footer-icon" />
                <a href="tel:+917350135259">+91 7350135259</a>
              </li>
              <li>
                <MdEmail className="footer-icon" />
                <span>info@rkconstructions.com</span>
              </li>
            </ul>
          </Col>
        </Row>

        {/* Bottom Copyright */}
        <Row className="footer-bottom">
          <Col className="text-center">
            <p className="footer-copyright">
              © {new Date().getFullYear()} R K Constructions |{" "}
              <a
                href="https://www.bighostindia.in/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-designer-link"
              >
                Design By: BigHost India Private Limited
              </a>
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
